<script setup lang="ts">
import { Head, usePage } from "@inertiajs/vue3";
import { computed } from "vue";

defineOptions({ inheritAttrs: false });
const page = usePage<{ organizations?: { id: number; name: string }[] }>();
const organizations = computed(() => page.props.organizations ?? []);
</script>

<template>
  <Head title="Organizations" />

  <main class="page-container-tight page-section">
    <h1 class="text-xl font-semibold tracking-tight sm:text-2xl">Organizations</h1>

    <ul class="mt-5 space-y-2">
      <li
        v-for="organization in organizations"
        :key="organization.id"
        class="rounded-xl border border-border/70 bg-card/80 px-4 py-3 text-sm font-medium transition active:scale-[0.98] hover:bg-muted/50"
      >
        {{ organization.name }}
      </li>
      <li v-if="organizations.length === 0" class="rounded-xl border border-dashed border-border/70 px-4 py-8 text-center text-sm text-muted-foreground">
        No organizations yet.
      </li>
    </ul>
  </main>
</template>
